import React from 'react'
import './Home.css'
import Story from '../components/Story'
import Reviews from '../components/Reviews'
import Steps from '../components/Steps'
import { FaUsers, FaHandsHelping, FaHeartbeat } from 'react-icons/fa'
import { Link } from 'react-router-dom'

function Home() {
  return (
    <div>

      <div className='hero-section'>
        <div className='hero-sub-section'>
          <h1 className='hero-header'>Compassionate Doula Services</h1>
          <p className='grey'>Experience expert care for pregnancy with our compassionate pregnancy support and doula services, ensuring a healthy journey for you and your baby.</p>
          <div className='row-justify-content-between'>
            <Link to='/inquiry' className=' button text-decoration-none'>
               Inquire About Services
            </Link>
          </div>
        </div>
        
        <div className='hero-sub-section'>
          <img src={require('../assets/home-hero-image.jpg')} alt="Hero" style={{width: '100%', height: '100%', maxHeight: '500px', objectFit: 'cover', borderRadius: '30px'}} />
        </div>
      </div>

      <div className='services-section'>
        <div className='column-container-content-center'>
          <h1 className='header2'>Our Services</h1>
          <h3 className='header4'>We specialise in education and support for families adjusting to new parenthood and caring for their newborns during the early weeks.</h3>
        </div>

        <div className='home-services-row'>
          <div className='home-service-card'>
            <div style={{width: '90px', height: '90px', borderRadius: '45px', backgroundColor: '#8AA7C7', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
              <FaUsers size={38} color="white" />
            </div>
            <h4>Sibling Support</h4>
            <p className='p-small  line-height-1-5'>Support for older siblings during the birth process, helping families transition smoothly and giving parents peace of mind.</p>
            <p className='link'>{`Learn More ->`}</p>
          </div>

          <div className='home-service-card'>
            <div style={{width: '90px', height: '90px', borderRadius: '45px', backgroundColor: '#8AA7C7', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
              <FaHandsHelping size={32} color="white" />
            </div>
            <h4>Postpartum Support</h4>
            <p className='p-small  line-height-1-5'>Practical and emotional care after birth, including feeding guidance, rest support, and help with newborn routines.</p>
            <p className='link'>{`Learn More ->`}</p>
          </div>

          <div className='home-service-card'>
            <div style={{width: '90px', height: '90px', borderRadius: '45px', backgroundColor: '#8AA7C7', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
              <FaHeartbeat size={32} color="white" />
            </div>
            <h4>Breastfeeding Doula Support</h4>
            <p className='p-small  line-height-1-5'>One-on-one breastfeeding support with continuous guidance, comfort measures, and informed assistance throughout the nursing journey.</p>
            <p className='link'>{`Learn More ->`}</p>
          </div>
        </div>
      </div>

      <Story />
      <Reviews />
      <Steps />

    </div>
  )
}

export default Home
